/**
 * Single-line CodeMirror extension — sl-zjgl post-Phase-5 add-on.
 *
 * Turns a standard `<TemplateEditor>` into a single-line input:
 *   - blocks Enter / paste-inserted newlines at the transaction layer
 *     (user can't insert a line break at all)
 *   - strips existing newlines from the initial doc on mount, so a
 *     value persisted before this extension was wired doesn't lock
 *     the editor into a two-line state
 *   - no line numbers, no active-line highlight (caller passes
 *     `lineNumbers: false` via `basicSetup`)
 *
 * Used by `TemplateInput`, which now renders a full CodeMirror editor
 * behind the same API (pills + autocomplete come from the shared
 * extension pipeline).
 */

import { EditorState } from '@codemirror/state';

/**
 * Build a `transactionFilter` that rejects any transaction whose result
 * would contain a newline. `newDoc.lines > 1` catches every insert
 * path — typed Enter, pasted blob, adapter `insertAtCursor`.
 *
 * Returning `[]` cancels the transaction. Selection-only transactions
 * (no doc change) pass through untouched so caret movement still works.
 */
export function singleLineTransactionFilter() {
  return EditorState.transactionFilter.of(tr =>
    tr.docChanged && tr.newDoc.lines > 1 ? [] : tr
  );
}
